// src/components/Admin/SuppliersTable.jsx
import React, { useState } from 'react';
import { Check, X, ExternalLink, Building2 } from 'lucide-react';
import './SuppliersTable.css';

export default function SuppliersTable({ suppliers, onUpdateStatus }) {
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = suppliers.filter(s =>
    s.company_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.gst_number?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.core_offering_category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.contact_person?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="suppliers-module-card">
      <div className="suppliers-toolbar">
        <div className="suppliers-toolbar-title">
          <h3>Accredited Suppliers Network</h3>
          <span className="supplier-count-pill">{suppliers.length} Partners</span>
        </div>

        <input
          type="text"
          className="suppliers-filter-input"
          placeholder="Search company, GSTIN, sector..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="suppliers-table-scroll">
        <table className="suppliers-table">
          <thead>
            <tr>
              <th>Enterprise Name</th>
              <th>GST Identification</th>
              <th>Sector / Category</th>
              <th>Authorized Signatory</th>
              <th>Status</th>
              <th>Verification Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(supplier => (
              <tr key={supplier.id}>
                <td>
                  <div className="company-title-cell">
                    <strong style={{ color: '#003666' }}>{supplier.company_name}</strong>
                    {supplier.company_website_url && (
                      <a
                        href={supplier.company_website_url}
                        target="_blank"
                        rel="noreferrer"
                        className="link-website-trigger"
                        title="Visit Official Storefront"
                      >
                        <ExternalLink size={12} />
                      </a>
                    )}
                  </div>
                </td>
                <td>
                  <span className="gst-code-badge">{supplier.gst_number}</span>
                </td>
                <td>
                  <span className="category-tag-badge">{supplier.core_offering_category}</span>
                </td>
                <td>
                  <div>{supplier.contact_person}</div>
                  <small style={{ color: '#64748b' }}>{supplier.mobile}</small>
                </td>
                <td>
                  <span className={`status-badge-supplier ${supplier.status}`}>
                    {supplier.status}
                  </span>
                </td>
                <td>
                  <div className="supplier-action-suite">
                    {supplier.status !== 'approved' && (
                      <button
                        className="btn-supplier-approve"
                        onClick={() => onUpdateStatus(supplier.id, 'approved')}
                        title="Approve Supplier"
                      >
                        <Check size={13} />
                        <span>Accredit</span>
                      </button>
                    )}
                    {supplier.status !== 'rejected' && (
                      <button
                        className="btn-supplier-reject"
                        onClick={() => onUpdateStatus(supplier.id, 'rejected')}
                        title="Reject Supplier"
                      >
                        <X size={13} />
                        <span>Reject</span>
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>
                  No corporate suppliers matching your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}